import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

const WrapperComponentControl = ({
  conditions = [{ roles: [], condition: true, user: undefined }],
  rolesAccess = [],
  children,
}) => {
  const login = useSelector(({ login }) => login)
  const [show, setShow] = useState(false)

  useEffect(() => {
    let accessRole = false
    if (rolesAccess !== undefined && rolesAccess.length != 0) {
      accessRole = login?.roles?.some((role) => rolesAccess.includes(role))
    } else {
      accessRole = true
    }

    let accessCondition = false
    if (accessRole) {
      if (conditions && conditions.length != 0) {
        accessCondition = conditions.every((cond) =>
          !cond.roles || cond.roles.length === 0 || login?.roles.some((role) => cond.roles.includes(role))
            ? (cond.condition === undefined || cond.condition === true) &&
              (cond.user === undefined || cond.user === login.iduser)
            : true,
        )
      } else {
        accessCondition = true
      }
    }

    setShow(accessRole && accessCondition)
  }, [conditions, rolesAccess])

  return <>{show && children}</>
}

export default WrapperComponentControl
